import {
  requireDateOnlyString,
  type DateOnlyString,
} from "../../utils/dateOnly";
import type { DateRange } from "../../components/reports/ReportDateRangePicker";

export interface CanonicalReportDateRangeParams {
  readonly startDate: DateOnlyString;
  readonly endDate: DateOnlyString;
}

export function canonicalReportDateRangeParams(
  range: DateRange
): CanonicalReportDateRangeParams {
  const startDate = datePickerValueToDateOnly(range.startDate, "Start date");
  const endDate = datePickerValueToDateOnly(range.endDate, "End date");
  if (startDate > endDate)
    throw new Error("Start date must not be after end date");
  return { startDate, endDate };
}

function datePickerValueToDateOnly(
  value: Date,
  fieldName: string
): DateOnlyString {
  if (Number.isNaN(value.getTime())) throw new Error(`${fieldName} is invalid`);
  const year = String(value.getFullYear()).padStart(4, "0");
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return requireDateOnlyString(`${year}-${month}-${day}`, fieldName);
}
